"use client";

import { c as _c } from "react/compiler-runtime";
import Button from "@/Components/Common/Buttons/Buttons";
import { useForm, Controller } from "react-hook-form";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useAvailabilityQuery } from "@/Redux/apis/appointments";
import useAvailability from "../../../../reactQuery/availability";
import { useDispatch, useSelector } from "react-redux";
import { useCreateAppointmentMutation } from "../../../../Redux/apis/appointments";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/style.css";
import { calendarDateFormat, calendarDateFormatInString, convertDateTimeToUTC, convertDateToUTC, convertTimeTo24HourWithDateFormat, convertTimeZoneOfDate, dayJsDate, filterAvailableSlots, generateAppointmentTimeSlots } from "@/utils/common";
import useAppointments from "@/reactQuery/appointment";
import socketService from "../../../../utils/socket";
import { convertAndSplitSchedule, convertTimeSlotsToUserTimezone, convertTimeSlotsWithDayAdjustment, convertUTCToUserTimezone, getDayOfWeek, getFileTypeFromUrl } from "../../../../utils/common";
import useHolidays from "@/reactQuery/holidays";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { sendMessageDB } from "@/services/message";
import useAppointmentAvailability, { getAppointmentsByDate } from "@/reactQuery/appointmentAvailability";
import { addMessage } from "@/Redux/slice/chatSlice";
import { store } from "@/Redux/store/store";
const CustomDateInput = t0 => {
  const $ = _c(7);
  const {
    value,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g clipRule="url(#clip0_265_11073)"><path d="M12.9109 1.23215H12.3141V0.628262C12.3141 0.283228 12.0344 0.00354004 11.6894 0.00354004C11.3444 0.00354004 11.0647 0.283228 11.0647 0.628262V1.23215H4.9353V0.628262C4.9353 0.283228 4.65561 0.00354004 4.31058 0.00354004C3.96555 0.00354004 3.68586 0.283228 3.68586 0.628262V1.23215H3.08909C1.38576 1.23215 0 2.61791 0 4.32121V12.9073C0 14.6107 1.38576 15.9964 3.08909 15.9964H12.9109C14.6142 15.9964 16 14.6107 16 12.9073V4.32121C16 2.61791 14.6142 1.23215 12.9109 1.23215ZM3.08909 2.48159H3.68586V3.6998C3.68586 4.04483 3.96555 4.32452 4.31058 4.32452C4.65561 4.32452 4.9353 4.04483 4.9353 3.6998V2.48159H11.0647V3.6998C11.0647 4.04483 11.3444 4.32452 11.6894 4.32452C12.0345 4.32452 12.3141 4.04483 12.3141 3.6998V2.48159H12.9109C13.9253 2.48159 14.7506 3.30685 14.7506 4.32121V4.91801H1.24944V4.32121C1.24944 3.30685 2.0747 2.48159 3.08909 2.48159ZM12.9109 14.747H3.08909C2.0747 14.747 1.24944 13.9217 1.24944 12.9073V6.16745H14.7506V12.9073C14.7506 13.9217 13.9253 14.747 12.9109 14.747ZM5.54962 8.6247C5.54962 8.96974 5.26993 9.24942 4.9249 9.24942H3.69629C3.35126 9.24942 3.07157 8.96974 3.07157 8.6247C3.07157 8.27967 3.35126 7.99998 3.69629 7.99998H4.9249C5.2699 7.99998 5.54962 8.27967 5.54962 8.6247ZM12.9285 8.6247C12.9285 8.96974 12.6488 9.24942 12.3037 9.24942H11.0751C10.7301 9.24942 10.4504 8.96974 10.4504 8.6247C10.4504 8.27967 10.7301 7.99998 11.0751 7.99998H12.3037C12.6487 7.99998 12.9285 8.27967 12.9285 8.6247ZM9.23548 8.6247C9.23548 8.96974 8.95579 9.24942 8.61076 9.24942H7.38215C7.03712 9.24942 6.75743 8.96974 6.75743 8.6247C6.75743 8.27967 7.03712 7.99998 7.38215 7.99998H8.61076C8.95576 7.99998 9.23548 8.27967 9.23548 8.6247ZM5.54962 12.3106C5.54962 12.6556 5.26993 12.9353 4.9249 12.9353H3.69629C3.35126 12.9353 3.07157 12.6556 3.07157 12.3106C3.07157 11.9655 3.35126 11.6858 3.69629 11.6858H4.9249C5.2699 11.6858 5.54962 11.9655 5.54962 12.3106ZM12.9285 12.3106C12.9285 12.6556 12.6488 12.9353 12.3037 12.9353H11.0751C10.7301 12.9353 10.4504 12.6556 10.4504 12.3106C10.4504 11.9655 10.7301 11.6858 11.0751 11.6858H12.3037C12.6487 11.6858 12.9285 11.9655 12.9285 12.3106ZM9.23548 12.3106C9.23548 12.6556 8.95579 12.9353 8.61076 12.9353H7.38215C7.03712 12.9353 6.75743 12.6556 6.75743 12.3106C6.75743 11.9655 7.03712 11.6858 7.38215 11.6858H8.61076C8.95576 11.6858 9.23548 11.9655 9.23548 12.3106Z" fill="#354EF0" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-4 h-4 relative flex-col justify-start items-start flex"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">{t1}<defs><clipPath id="clip0_265_11073"><rect width="16" height="16" fill="white" /></clipPath></defs></svg></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== value) {
    t3 = <div className="text-black text-xs font-medium font-poppins">{value}</div>;
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick || $[5] !== t3) {
    t4 = <div onClick={onClick} className="w-[356px] self-stretch px-4 pt-2 mt-2 cursor-pointer pb-2.5 bg-neutral-50 rounded-lg border border-blue-600 justify-start items-center gap-4 inline-flex">{t2}{t3}</div>;
    $[4] = onClick;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
const BookAppointments = ({
  onClose,
  repData,
  reason = null,
  requestedAppointmentIdData = null
}) => {
  const defaultClassNames = getDefaultClassNames();
  const [load, setLoad] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availabilityData, setAvailabilityData] = useState();
  const [availableSlots, setAvailableSlots] = useState();
  const users = useSelector(state => state?.userData?.userData?.user);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [holidaysList, setHolidaysList] = useState([]);
  const {
    availability,
    saveAvailabilityMutation
  } = useAvailability({
    userId: repData?._id
  });
  const {
    appointmentAvailabilityProvider
  } = useAppointmentAvailability({
    repId: repData?._id,
    userId: users?._id,
    date: selectedDate
  });
  const {
    holidays
  } = useHolidays({
    userId: repData?._id
  });
  const dispatch = useDispatch();
  const [createAppointmentApi, createAppointmentResponse] = useCreateAppointmentMutation();
  const slotRef = useRef(null);
  console.log("TIMEZONE_BookAppointments", JSON.stringify(appointmentAvailabilityProvider));
  console.log("TIMEZONE_BookAppointments", JSON.stringify(availableSlots ?? {}));
  useEffect(() => {
    if (holidays.length > 0) {
      const holidayArray = holidays.map(holiday => {
        return new Date(holiday.date);
      });
      setHolidaysList(holidayArray);
    }
  }, [holidays]);
  useEffect(() => {
    if (!availability.isLoading) {
      const availabilityDataFromDb = availability?.data?.availability;
      if (availabilityDataFromDb && availabilityDataFromDb?.schedule) {
        let convertedSchedule = {};
        convertedSchedule = convertAndSplitSchedule(availabilityDataFromDb?.schedule, availabilityDataFromDb.userId.timezone, users?.timezone, availabilityDataFromDb?.duration);
        availabilityDataFromDb.schedule = convertedSchedule;
      }
      setAvailabilityData(availabilityDataFromDb ? availabilityDataFromDb : []);
    } else if (availability?.isError) {
      setAvailabilityData([]);
    }
  }, [availability?.data, availability?.isLoading, availability?.isError]);
  // useEffect(()=>{
  //   handleDateChange(new Date())
  // },[availabilityData])

  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      reason: reason || ""
    }
  });
  const dateValue = watch('date');
  useEffect(() => {}, [dateValue, availabilityData]);
  const onSubmit = async data => {
    console.log('=====data', data);
    if (!selectedSlot) {
      toast.error("Please select a slot.");
      return;
    }
    console.log(data.date, calendarDateFormat(data.date), 'qwerty');
    // return
    setLoad(true);
    // startTime: convertDateTimeToUTC(data.date, selectedSlot.startTime),
    // endTime: convertDateTimeToUTC(data.date, selectedSlot.endTime),
    // date: convertDateToUTC(data.date),
    const payload = {
      startTime: convertDateTimeToUTC(calendarDateFormat(data.date), selectedSlot.startTime),
      endTime: convertDateTimeToUTC(calendarDateFormat(data.date), selectedSlot.endTime),
      date: convertDateToUTC(calendarDateFormat(data.date)),
      type: 'client',
      reason: data.reason,
      doctorId: users._id,
      repId: repData?._id
    };
    console.log(payload, 'payload');
    await createAppointmentApi(payload);
  };
  useEffect(() => {
    console.log("selectedDate", selectedDate);
    if (selectedDate && slotRef.current) {
      slotRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [selectedDate]);
  const handleDateChange = async date => {
    if (!date) {
      return;
    }
    console.log(date, 'date || new Date()');
    let dateValue_0 = date;
    if (dateValue_0) {
      const dayOfWeek = getDayOfWeek(dateValue_0);
      if (dayOfWeek === null || dayOfWeek === undefined) {
        setAvailableSlots(null);
        return;
      }
      const nowInToZone = dayjs().tz(users?.timezone);

      // Check if the selected date is today
      const isToday = dayjs(dateValue_0).isSame(nowInToZone, 'day');
      console.log("TIMEZONE_BookAppointments.jsx", isToday, `DateValue: ${dateValue_0}`, `TIMEZONE: ${nowInToZone}`, availabilityData);
      const appointmentData = await getAppointmentsByDate(users?._id, repData?._id, date);
      if (isToday) {
        console.log("TIMEZONE_BookAppointments_today", availabilityData?.schedule?.today);
        const availableTimeSlots = filterAvailableSlots(availabilityData?.schedule?.today, appointmentData);
        setAvailableSlots(availableTimeSlots || []);
      } else {
        const slotsForDay = availabilityData?.schedule?.otherDays[dayOfWeek] || [];
        const availableTimeSlots_0 = filterAvailableSlots(availabilityData?.schedule?.otherDays[dayOfWeek], appointmentData);
        console.log("TIMEZONE_BookAppointments_other", JSON.stringify(slotsForDay), JSON.stringify(appointmentData));
        setAvailableSlots(availableTimeSlots_0);
      }
      setSelectedSlot(null);
      setSelectedDate(date);
      setValue("date", date);
      console.log("APP_DATA", appointmentData);
    }
  };
  useEffect(() => {
    handleCreateAppointmentResponse();
  }, [createAppointmentResponse]);
  const handleCreateAppointmentResponse = async () => {
    if (createAppointmentResponse?.isLoading) {
      setLoad(true);
    } else if (!createAppointmentResponse?.isLoading && createAppointmentResponse?.isSuccess) {
      console.log(createAppointmentResponse);
      let message = createAppointmentResponse?.data?.slot;
      console.log('message', message);
      const msgResponse = await sendMessageDB({
        senderId: message?.doctorId,
        receiverId: message?.repId,
        profilePic: users?.profile,
        appointmentId: message?._id,
        reason: message?.reason,
        senderName: users?.firstName + " " + users.lastName,
        createdAt: new Date().toISOString()
      });
      store.dispatch(addMessage({
        success: true,
        data: msgResponse?.data
      }));
      socketService.sendMessage(msgResponse);
      if (requestedAppointmentIdData) {
        socketService.scheduleRequestedMeeting({
          senderId: message?.doctorId,
          receiverId: message?.repId,
          appointmentId: message?._id,
          requestedAppointmentId: requestedAppointmentIdData?._id
        });
      }
      toast.success('Appointment booked successfully!');
      onClose();
      setLoad(false);
    } else if (createAppointmentResponse?.isError && createAppointmentResponse?.status === "rejected") {
      setLoad(false);
      toast.error(createAppointmentResponse?.error?.data?.message);
    }
  };

  // Portal to <body> so the popup escapes ancestor stacking contexts
  // and the dashboard navbar (z-[11]) can't bleed over the modal.
  // SSR guard is the cheap `typeof document` check — no useEffect
  // tick, so the modal renders on the very first frame.
  if (typeof document === "undefined") return null;
  const modal = <>
      <div className="fixed inset-0 popup-bg z-[9999] flex justify-center items-end sm:items-center">
        <div className="w-full sm:w-[390px] h-full sm:h-auto sm:max-h-[90vh] bg-white rounded-none sm:rounded-2xl shadow border border-neutral-200 flex flex-col overflow-hidden">
          {/* Header */}
          <div className="w-full flex justify-between items-center px-4 pt-4 pb-3 border-b border-neutral-200 flex-shrink-0">
            <div className="text-black text-base font-semibold font-poppins">
              Book appointment
            </div>
            <div onClick={onClose} className="w-6 h-6 cursor-pointer flex items-center justify-center hover:bg-gray-100 rounded-full">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white" />
                <path fillRule="evenodd" clipRule="evenodd" d="M5.00073 17.5864C4.61023 17.977 4.61029 18.6101 5.00085 19.0006C5.39141 19.3911 6.02457 19.3911 6.41506 19.0005L12.0003 13.4143L17.586 19C17.9765 19.3905 18.6097 19.3905 19.0002 19C19.3907 18.6095 19.3907 17.9763 19.0002 17.5858L13.4144 12L18.9998 6.41359C19.3902 6.02303 19.3902 5.38987 18.9996 4.99938C18.6091 4.60888 17.9759 4.60894 17.5854 4.9995L12.0001 10.5858L6.41438 4.99998C6.02386 4.60946 5.39069 4.60946 5.00017 4.99998C4.60964 5.39051 4.60964 6.02367 5.00017 6.4142L10.5861 12.0001L5.00073 17.5864Z" fill="#8E8E8E" />
              </svg>
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="w-full flex-1 flex flex-col overflow-hidden">
            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-4 py-4">
              <div className="w-full flex-col justify-start items-start gap-3 inline-flex">
                <div className="flex-col w-full justify-start items-start gap-2 flex">
                  <div className="text-neutral-400 text-xs font-medium font-poppins">
                    Appointment Reason
                  </div>

                  <div className="w-full">
                    <textarea {...register("reason", {
                    required: "Reason is required"
                  })} className="p-2 border w-full border-blue-600 rounded-lg text-sm" rows="2" style={{
                    resize: "none"
                  }} />
                    {errors.reason && <p className="text-red-500 text-xs">{errors.reason.message}</p>}
                  </div>
                </div>
                <div className="flex-col w-full justify-start items-start flex">
                  <div className="text-neutral-400 text-xs mb-2 font-medium font-poppins">
                    Appointment Date
                  </div>
                  <div className="text-black text-xs font-medium font-poppins w-full overflow-x-auto">
                    <Controller control={control} name="date" rules={{
                    required: "Appointment Date is required"
                  }} render={({
                    field
                  }) => {
                    const localDate = convertUTCToUserTimezone(field.value, users?.timezone);
                    return <DayPicker mode="single" selected={selectedDate} onSelect={(date_0, triggerDate) => {
                      console.log("selectedDate1", date_0, triggerDate);
                      handleDateChange(date_0);
                    }} disabled={[...holidaysList, {
                      before: new Date()
                    }]} hidden={[]} classNames={{
                      root: `${defaultClassNames.root} border-solid border-2 border-neutral-100 rounded-lg p-2 sm:p-3.5`,
                      chevron: `${defaultClassNames.chevron} fill-[#354EF0]`
                    }} />;
                  }} />
                    {errors.date && <p className="text-red-500 text-xs">{errors.date.message}</p>}
                  </div>
                </div>
                {watch("date") && <div className="w-full flex-col pt-4 justify-start items-start gap-2 flex" ref={slotRef}>
                  <div className="text-neutral-400 text-xs font-medium font-poppins">
                    Appointment Slot
                  </div>
                  <div key={selectedDate} className="w-full justify-start items-center gap-2 flex flex-wrap">
                    {availableSlots && availableSlots?.length > 0 ? availableSlots?.map((slot, key) => <div key={key} onClick={() => setSelectedSlot(slot)} className={`px-2 py-2.5 w-[calc(50%-4px)] cursor-pointer rounded-lg border justify-center items-center gap-1 flex
                          ${convertTimeTo24HourWithDateFormat(selectedSlot?.startTime) == convertTimeTo24HourWithDateFormat(slot.startTime) && convertTimeTo24HourWithDateFormat(selectedSlot?.endTime) == convertTimeTo24HourWithDateFormat(slot.endTime) ? "bg-[#2e45df] text-[#fff]" : "bg-neutral-100 border-blue-600 text-neutral-600 "}
                          `}>
                        <div className="text-[10px] sm:text-[12px] font-medium font-poppins whitespace-nowrap">
                          {convertTimeTo24HourWithDateFormat(slot?.startTime)} - {convertTimeTo24HourWithDateFormat(slot?.endTime)}
                        </div>
                      </div>) : <p className="text-black text-sm">Slot not available!</p>}
                  </div>
                </div>}
              </div>
            </div>

            {/* Fixed Bottom Button */}
            <div className="w-full px-4 py-3 border-t border-gray-200 flex-shrink-0 mt-auto bg-white">
              <Button disabled={!selectedSlot} backgroundColor={`${!selectedSlot ? '#838383' : '#2e45df'} `} padding={"12px 0px"} borderRadius={"10px"} textColor={"white"} fontSize={"14px"} fontWeight={500} type="submit">
                {load ? 'Loading...' : 'Book Appointment'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>;
  return createPortal(modal, document.body);
};
export default BookAppointments;